<template>
  <v-dialog
    :persistent="loading"
    :value="value"
    @input="$emit('input', $event)"
    max-width="600px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t("COMMON.CHANGE_PASSWORD") }}</span>
        <v-spacer />
        <tk-btn :disabled="loading" icon @click="$emit('input', !value)">
          <v-icon>fas fa-times</v-icon>
        </tk-btn>
      </v-card-title>

      <v-card-text>
        <v-form @submit.prevent="submit">
          <v-text-field
            v-model="$auth.currentUser.email"
            autocomplete="username"
            :error-messages="errors.email"
            :label="$t('COMMON.EMAIL')"
            readonly
          />

          <v-text-field
            type="password"
            v-model="form.old_password"
            autocomplete="current-password"
            :error-messages="errors.old_password"
            :label="$t('ACCOUNT.OLD_PASSWORD')"
            required
          />
          <v-text-field
            v-model="form.new_password"
            type="password"
            autocomplete="new-password"
            required
            :error-messages="errors.new_password"
            :label="$t('ACCOUNT.NEW_PASSWORD')"
          />
          <v-text-field
            v-model="form.new_password_confirmation"
            autocomplete="new-password"
            type="password"
            required
            :error-messages="errors.new_password_confirmation"
            :label="$t('SIGNUP.REPEAT_PASSWORD')"
          />
          <div class="text-xs-right">
            <tk-btn :loading="loading" type="submit" color="primary">{{
              $t("COMMON.SUBMIT")
            }}</tk-btn>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["value"],

  data() {
    return {
      loading: false,
      form: {},
      errors: {},
    };
  },

  methods: {
    async submit() {
      this.errors = {};
      this.loading = true;
      try {
        await this.$axios.put("password/update", this.form);
        this.$app.toast(this.$t("ACCOUNT.PASSWORD_CHANGED_SUCCESS"));
        this.$emit("input", !this.value);
      } catch (error) {
        if (error.status === 422 && error.data) {
          this.errors = error.data.errors;
        }
        if (error.status === 401 && error.data) {
          this.errors["old_password"] = [error.data.message];
        }
      }
      this.loading = false;
    },
  },
};
</script>

